// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_USER_INFO,
    APP_USER_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    getUserInfo: state => state.apiInfo
}

const actions = {
    getUserInfo({commit}, options) {
        var uri = API_AI + "/h5/auth/getAccessToken/" + options.data.id
        return new Promise((resolve, reject) => {
            Vue.http.post(uri,{
                client_id : options.data.key,
                client_secret : options.data.secret,
                grant_type : 'authorization_code',
                redirect_uri : location.href,
                code : options.data.code
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_USER_INFO, res)
            }, (err) => {
                commit(APP_USER_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_USER_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_USER_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/getWxUser.js